<template>
    <transition
      name="unpin-slide"
      @after-leave="afterLeave"
    >
      <div v-if="!isLeaving" class="info-card" :class="{ expanded: expanded.billing, collapsed: !expanded.billing }">
      <div class="info-card-content">
        <div v-if="!expanded.billing">
          <div class="info-row">
            <div class="icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" fill="none">
                    <path d="M7.25 16C6.41667 16 5.70833 15.7083 5.125 15.125C4.54167 14.5417 4.25 13.8333 4.25 13H1.75L2.2 11H5.025C5.30833 10.6833 5.64167 10.4375 6.025 10.2625C6.40833 10.0875 6.81667 10 7.25 10C7.68333 10 8.09167 10.0875 8.475 10.2625C8.85833 10.4375 9.19167 10.6833 9.475 11H13.65L15.75 2H4.8L4.9 1.575C5 1.10833 5.22917 0.729167 5.5875 0.4375C5.94583 0.145833 6.36667 0 6.85 0H18.25L17.325 4H20.25L23.25 8L22.25 13H20.25C20.25 13.8333 19.9583 14.5417 19.375 15.125C18.7917 15.7083 18.0833 16 17.25 16C16.4167 16 15.7083 15.7083 15.125 15.125C14.5417 14.5417 14.25 13.8333 14.25 13H10.25C10.25 13.8333 9.95833 14.5417 9.375 15.125C8.79167 15.7083 8.08333 16 7.25 16ZM16.175 9H21L21.1 8.475L19.25 6H16.875L16.175 9ZM15.7 2.175L15.75 2L13.65 11L13.7 10.825L14.55 7.175L15.7 2.175ZM0.75 9.325L1.25 7.325H6.75L6.25 9.325H0.75ZM2.75 5.675L3.25 3.675H9.75L9.25 5.675H2.75ZM7.25 14C7.53333 14 7.77083 13.9042 7.9625 13.7125C8.15417 13.5208 8.25 13.2833 8.25 13C8.25 12.7167 8.15417 12.4792 7.9625 12.2875C7.77083 12.0958 7.53333 12 7.25 12C6.96667 12 6.72917 12.0958 6.5375 12.2875C6.34583 12.4792 6.25 12.7167 6.25 13C6.25 13.2833 6.34583 13.5208 6.5375 13.7125C6.72917 13.9042 6.96667 14 7.25 14ZM17.25 14C17.5333 14 17.7708 13.9042 17.9625 13.7125C18.1542 13.5208 18.25 13.2833 18.25 13C18.25 12.7167 18.1542 12.4792 17.9625 12.2875C17.7708 12.0958 17.5333 12 17.25 12C16.9667 12 16.7292 12.0958 16.5375 12.2875C16.3458 12.4792 16.25 12.7167 16.25 13C16.25 13.2833 16.3458 13.5208 16.5375 13.7125C16.7292 13.9042 16.9667 14 17.25 14Z" fill="#374957"/>
                  </svg>
            </div>
            <p class="info-text-title">Order Handling Preference:</p>
          </div>
        </div>
            <div v-else> 
              <div class="flex flex-row gap-2">
                <div class="icon-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" fill="none">
                        <path d="M7.25 16C6.41667 16 5.70833 15.7083 5.125 15.125C4.54167 14.5417 4.25 13.8333 4.25 13H1.75L2.2 11H5.025C5.30833 10.6833 5.64167 10.4375 6.025 10.2625C6.40833 10.0875 6.81667 10 7.25 10C7.68333 10 8.09167 10.0875 8.475 10.2625C8.85833 10.4375 9.19167 10.6833 9.475 11H13.65L15.75 2H4.8L4.9 1.575C5 1.10833 5.22917 0.729167 5.5875 0.4375C5.94583 0.145833 6.36667 0 6.85 0H18.25L17.325 4H20.25L23.25 8L22.25 13H20.25C20.25 13.8333 19.9583 14.5417 19.375 15.125C18.7917 15.7083 18.0833 16 17.25 16C16.4167 16 15.7083 15.7083 15.125 15.125C14.5417 14.5417 14.25 13.8333 14.25 13H10.25C10.25 13.8333 9.95833 14.5417 9.375 15.125C8.79167 15.7083 8.08333 16 7.25 16ZM16.175 9H21L21.1 8.475L19.25 6H16.875L16.175 9ZM15.7 2.175L15.75 2L13.65 11L13.7 10.825L14.55 7.175L15.7 2.175ZM0.75 9.325L1.25 7.325H6.75L6.25 9.325H0.75ZM2.75 5.675L3.25 3.675H9.75L9.25 5.675H2.75ZM7.25 14C7.53333 14 7.77083 13.9042 7.9625 13.7125C8.15417 13.5208 8.25 13.2833 8.25 13C8.25 12.7167 8.15417 12.4792 7.9625 12.2875C7.77083 12.0958 7.53333 12 7.25 12C6.96667 12 6.72917 12.0958 6.5375 12.2875C6.34583 12.4792 6.25 12.7167 6.25 13C6.25 13.2833 6.34583 13.5208 6.5375 13.7125C6.72917 13.9042 6.96667 14 7.25 14ZM17.25 14C17.5333 14 17.7708 13.9042 17.9625 13.7125C18.1542 13.5208 18.25 13.2833 18.25 13C18.25 12.7167 18.1542 12.4792 17.9625 12.2875C17.7708 12.0958 17.5333 12 17.25 12C16.9667 12 16.7292 12.0958 16.5375 12.2875C16.3458 12.4792 16.25 12.7167 16.25 13C16.25 13.2833 16.3458 13.5208 16.5375 13.7125C16.7292 13.9042 16.9667 14 17.25 14Z" fill="#374957"/>
                      </svg>
                </div>
                <div class="flex flex-col gap-1">
                  <p class="info-text-title">Order Handling Preference:</p>
                  <p class="blood-kit-info-text">Blood Kit:</p>
                  <p class="info-text"> {{ orderHandlingData.bloodKit }}</p>
                  <p class="blood-kit-info-text">None-Blood Kit:</p>
                  <p class="info-text"> {{ orderHandlingData.nonBloodKit }}</p>
                </div>
              </div>
              <div class="flex flex-row gap-2">
                <div class="icon-container mt-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                        <path d="M5 11H7V8.25H9V11H11V6.25L8 4.25L5 6.25V11ZM8 17.35C10.0333 15.4833 11.5417 13.7875 12.525 12.2625C13.5083 10.7375 14 9.38333 14 8.2C14 6.38333 13.4208 4.89583 12.2625 3.7375C11.1042 2.57917 9.68333 2 8 2C6.31667 2 4.89583 2.57917 3.7375 3.7375C2.57917 4.89583 2 6.38333 2 8.2C2 9.38333 2.49167 10.7375 3.475 12.2625C4.45833 13.7875 5.96667 15.4833 8 17.35ZM8 20C5.31667 17.7167 3.3125 15.5958 1.9875 13.6375C0.6625 11.6792 0 9.86667 0 8.2C0 5.7 0.804167 3.70833 2.4125 2.225C4.02083 0.741667 5.88333 0 8 0C10.1167 0 11.9792 0.741667 13.5875 2.225C15.1958 3.70833 16 5.7 16 8.2C16 9.86667 15.3375 11.6792 14.0125 13.6375C12.6875 15.5958 10.6833 17.7167 8 20Z" fill="#374957"/>
                      </svg>
                </div>
                <div class="flex flex-col gap-1 mt-2">
                  <p class="info-text-title">Shipping Address:</p>
                  <p class="info-text">{{ orderHandlingData.shippingAddress }}</p>
                </div>
            </div>
          </div>
          <div v-if="expanded.billing" class="action-icons">
            <div v-if="!isCardPinned" class="action-icon" @click.stop="handlePinCard">
              <img src="@/assets/cardActions/pin.svg" alt="Unpin" />
            </div>
            <div v-if="isCardPinned" class="action-icon" @click.stop="startUnpin">
              <img src="@/assets/cardActions/unpin.svg" alt="Pin" />
            </div>
            <div v-if="showFooter" class="action-icon" @click.stop="toggleCard('billing')">
              <img src="@/assets/cardActions/collapse.svg" alt="Collapse" />
            </div>
          </div>
          <div v-else class="flex flex-row items-center gap-2">
            <div @click.stop="toggleCard('billing')" class="action-icon">
              <img src="@/assets/cardActions/expand.svg" alt="Expand" />
            </div>
            <div class="drag-handle action-icon">
              <img src="@/assets/cardActions/move.svg" alt="Move" />
            </div>
          </div>
      </div>
      <div class="card-expand" :class="{ 'justify-end': !showFooter, 'justify-between': showFooter }">
        <FoldableButton v-if="showFooter" customized_class="drag-handle" text="Move">
          <template #prefix>
            <img src="@/assets/cardActions/move.svg" alt="Move" />
          </template>
        </FoldableButton>
        <div class="flex flex-row gap-1 justify-end">
          <FoldableButton text="View">
            <template #prefix>
              <img src="@/assets/cardActions/view.svg" alt="View" />
            </template>
          </FoldableButton>
          <FoldableButton text="Resend">
            <template #prefix>
              <img src="@/assets/cardActions/resend.svg" alt="Resend" />
            </template>
          </FoldableButton>
        </div>
      </div>
    </div>
  </transition>
  
  
  </template>
  <script setup>
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';
  import { useCardActions } from '@/composables/useCardActions';
  import { useMyPatientsStore } from '@/store/helpers';
  
  // Define props
  const props = defineProps({
    patient: {
      type: String,
      default: ''
    },
    cardData: {
      type: Object,
      default: () => ({})
    },
    showFooter: {
      type: Boolean,
      default: true
    }
  })
  
  // Define emits
  const emit = defineEmits(['unpin-card', 'pin-card']);
  
  const { patientInfoStore } = useMyPatientsStore();
  const { isCardPinned, handlePinCard, handleUnpinCard } = useCardActions(props, emit);
  
  const isLeaving = ref(false);
  
  
  const startUnpin = () => {
    if(props.showFooter){
      isLeaving.value = true; // triggers the leave animation
    } else {
      handleUnpinCard()
    }
  };
  
  
  // This is called after the leave animation finishes
  const afterLeave = () => {
    emit('unpin-card', props.cardData); // parent removes the card
  };
  
  
  
  
  const expanded = ref({
    billing: true,
      })
  
  const toggleCard = (cardType) => {
        expanded.value[cardType] = !expanded.value[cardType]
      }
  
  
  // Get billing data from store
  const orderHandlingData = computed(() => {
    return patientInfoStore.getters.getOrderHandlingCardData(props.patient) || {
      bloodKit: 'Not Provided',
      nonBloodKit: 'Not Provided', 
      shippingAddress: 'Not Provided', 
    }
  })
  
  
  
  </script>
  
  
  <style scoped>
  .blood-kit-info-text {
    font-weight: 500;
    font-size: 14px;
  }
  .pin-toggle {
    position: relative;
    cursor: pointer;
  }
  
  .pin-toggle .icon {
    position: absolute;
    transition: opacity 0.3s ease, transform 0.3s ease;
  }
  
  .pin-toggle .unpin {
    opacity: 0;
    transform: scale(0.8);
  }
  
  /* Hover effect */
  .pin-toggle:hover .pin {
    opacity: 0;
    transform: scale(1);
  }
  
  .pin-toggle:hover .unpin {
    opacity: 1;
    transform: scale(1);
  }
  
  
  .unpin-slide-leave-active {
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), 
                opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .unpin-slide-leave-to {
    transform: translateX(-100%) scale(0.95);
    opacity: 0;
  }
  
  .peg-board-title {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 22px;
    color: #ffffff;
    text-align: center;
    margin-bottom: 16px;
  }
  
  .peg-board-content {
    display: flex;
    flex-direction: column;
    gap: 6px;
    overflow-y: auto;
    padding: 0 8px;
  }
  
  .info-card {
    background-color: white;
    border-radius: 5px;
    padding: 12px 16px;
    box-shadow: 0px 1px 25px 0px rgba(74, 74, 74, 0.15);
  }
  
  .info-card-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
  }
  
  .info-card-content-col-group {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 16px;
  }
  
  .info-row-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex-grow: 1;
  }
  
  .info-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .icon-container {
    background-color: #f2f2f2;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .icon-style {
    width: 20px;
    height: 20px;
  }
  
  .info-text {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0.25px;
    line-height: 20px;
  }
  
  .action-icons {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .action-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
  
  .appointment-date {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 50px;
    height: 64px;
    border-radius: 5px;
    background-color: #ffffff;
    box-shadow: 0px 1px 15px 0px rgba(74, 74, 74, 0.1);
    overflow: hidden;
  }
  
  .month {
    background-color: #004879;
    color: white;
    width: 100%;
    text-align: center;
    padding: 2px 0;
    font-size: 14px;
  }
  
  .day {
    color: rgba(0, 0, 0, 0.65);
    text-align: center;
    font-family: Lato;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 120% */
    text-transform: capitalize;
    height: 24px;
  }
  
  .weekday {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 1;
    padding-bottom: 3px;
  }
  
  .appointment-details {
      flex-grow: 1;
  }
  
  .detail-title {
      font-size: 12px;
      color: #666;
  }
  .detail-text {
      font-size: 14px;
      color: #333;
      margin-bottom: 4px;
  }
  .action-icons-appointment {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding-top: 20px;
  }
  .info-text-title {
      font-family: 'Inter', sans-serif;
      font-size: 12px;
      color: #666;
  }
  .info-text-large {
      font-family: 'Inter', sans-serif;
      font-size: 16px;
      color: #333;
      font-weight: 500;
  }
  
  /* Badge for billing preference */
  .badge {
    color: #25B8C2;
    font-family: Inter;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px; /* 120% */
    letter-spacing: 0.25px;
    display: flex;
    padding: 4px 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    font-family: 'Inter', sans-serif;
  }
  
  .badge-default {
    border-radius: 20px;
    background: #EBFFF8;
    width: 80px;
    font-family: 'Inter', sans-serif;
  }
  
  /* Expanded card footer visibility with hover expand animation */
  .card-expand {
    display: flex;
    align-items: center;
    gap: 16px;
    /* animation base state */
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    padding-top: 0;
    margin-top: 0;
    border-top: 1px dashed var(--DividerGray, #C4C4C4);
    border-top-color: transparent;
    pointer-events: none;
    transition: max-height 300ms linear,
                opacity 300ms linear,
                padding-top 300ms linear,
                margin-top 300ms linear,
                border-top-color 300ms linear;
  }
  
  .info-card.expanded:hover .card-expand {
    /* ensure enough room for actions */
    max-height: 80px;
    opacity: 1;
    padding-top: 10px;
    margin-top: 10px;
    border-top-color: var(--DividerGray, #C4C4C4);
    pointer-events: auto;
  }
  
  .expand-action {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #1B79A0;
    cursor: pointer;
    padding: 4px 10px;
    border-radius: 5px;
  }
  
  .expand-action span {
    color: var(--color-Darkblue-000, #1E4670);
    text-align: center;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
  
  
  .action-icon {
    width: 28px;          /* w-7 */
    height: 28px;         /* h-7 */
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;   /* rounded-[5px] */
    padding: 5px;         /* pd-5 (assuming you meant padding) */
    cursor: pointer;
    transition: background-color 0.2s; /* duration-200 transition-colors */
  }
  
  .action-icon:hover,
  .expand-action:hover {
    background-color: #E5F1FB; /* hover:bg-[#E5F1FB] */
  }
  </style>
  
